var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFields(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5, 8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-0.5,-7.5 -6.5,-2.5 -4.5,-0.5 -0.3,-0.5",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.5,-7.5 5.5,-2 3.5,-0.5 0.3,-0.5",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-0.5,7.5 -5.5,2.5 -3.5,0.5 -0.3,0.5",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.5,7.5 6.5,2 4.5,0.5 0.3,0.5",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFields);
export default __webpack_public_path__ + "static/media/fields.d8537b46.svg";
export { ForwardRef as ReactComponent };